import { useConfigUserFeedback } from './config-user-feedback-state';

export const useAddConfigMessage = () => {
  const { addConfigMessage } = useConfigUserFeedback((state) => ({
    addConfigMessage: state.addConfigMessage,
  }));

  return addConfigMessage;
};
